import React, { useState, useEffect } from 'react';
import './index.css';
import { Button, Form, InputGroup, Modal } from 'react-bootstrap';
import { IoArrowBackOutline, IoChevronForward, IoCloseOutline } from 'react-icons/io5';
import { query, collection, onSnapshot, orderBy, getDocs } from "firebase/firestore";
import { db } from './../../../firebase';
import { IoMdAdd } from 'react-icons/io';
import SelectUnit from './select-unit';
import { useAuth } from '../../../context/AuthContext';
import BookedUnit from './booked-unit';

function PropertiesModal({ title, buttonTitle, buttonClass, buttonVariant, buttonSize, bookedData, handleResponse }) {

  const { user } = useAuth();
  const { bid } = user.claims;

  const [show, setShow] = useState(false);
  const [data, setData] = useState(null);
  const [paymentPlans, setPaymentPlans] = useState(null);
  const [towers, setTowers] = useState(null);
  const [units, setUnits] = useState(null);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [selectedData, setSelectedData] = useState(bookedData ? bookedData : null);
  const [selectedPayments, setSelectedPayments] = useState(null);
  const [selectedPaymentPlan, setSelectedPaymentPlan] = useState(null);
  const [basicPrices, setBasicPrices] = useState([]);
  const [additionalChargesData, setAdditionalChargesData] = useState([]);
  const [additionalCharges, setAdditionalCharges] = useState([]);

  const handleClose = () => {
    setUnits(null);
    setPaymentPlans(null);
    setShow(false);
    setSelectedProperty(null);
  };
  const handleShow = () => {
    setUnits(null);
    setShow(true);
  };

  useEffect(() => {
    const q = query(collection(db, "Businesses", bid, "Properties"), orderBy('addedOn'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const tempData = [];
      querySnapshot.forEach((doc) => {
        tempData.push({ id: doc.id, ...doc.data() });
      });

      setData(tempData);
    }, (error) => {
      console.log(error.message);
    });

    return () => unsubscribe;
  }, []);

  async function getPayments(propID, planID) {
    const q = query(collection(db, "Businesses", bid, "Properties", propID, "PaymentPlans", planID, "Payments"), orderBy("serialNumber"));
    const querySnapshot = await getDocs(q);
    const tempData = [];
    querySnapshot.forEach((doc) => {
      var tempDoc = doc.data();
      delete tempDoc.addedOn;
      delete tempDoc.updatedOn;
      tempData.push({ id: doc.id, ...tempDoc });
    });

    setSelectedPayments(tempData);
  }

  async function getPaymentPlans(propID, towID) {
    const q = query(collection(db, "Businesses", bid, "Properties", propID, "PaymentPlans"), orderBy("serialNumber"));
    const querySnapshot = await getDocs(q);
    const tempData = [];
    querySnapshot.forEach((doc) => {
      if (doc.data().towerID === towID) {
        tempData.push({ id: doc.id, ...doc.data() });
      }
    });
    if (tempData && tempData.length > 0) {
      setSelectedPaymentPlan({ id: tempData[0].id, name: tempData[0].name });
      getPayments(propID, tempData[0].id);
    }
    setPaymentPlans(tempData);
  }

  function getTowers(propID) {
    const q = query(collection(db, "Businesses", bid, "Properties", propID, "Towers"), orderBy('name'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const tempData = [];
      querySnapshot.forEach((doc) => {
        tempData.push({ id: doc.id, ...doc.data() });
      });

      setTowers(tempData);
      setSelectedProperty(propID);
    }, (error) => {
      console.log(error.message);
    });

    return () => unsubscribe;
  }

  function handleSelectPropertyData(item, tower) {
    let tempData = {
      propertyID: item.id,
      propName: item.name,
      propTotalArea: item.totalArea,
      propUnitMeasure: item.unitMeasure,
      propType: item.type,
      propNumber: item.number,
      propLocality: item.locality,
      propCity: item.city,
      propState: item.state,
      propPincode: item.pincode,
      propTower: tower
    };

    setSelectedData(tempData);
  }

  async function getPropertyUnits(propItem, tower, unitMeasure) {
    const querySnapshot = await getDocs(collection(db, "Businesses", bid, "Properties", propItem.id, "Units"));
    const tempData = [];
    querySnapshot.forEach((doc) => {
      if (doc.data().tower.id === tower.id) {
        tempData.push({ id: doc.id, unitMeasure: unitMeasure, ...doc.data() });
      }
    });
    handleSelectPropertyData(propItem, tower);
    setUnits(tempData);
  }

  const setUnitNumberPerFloor = (unitData, unitFloor, unitNumber) => {
    const tempBasicPrice = unitData && unitData.basicPrice.sort(function (a, b) { return b.date.seconds - a.date.seconds })[0];
    const tempUnitData = {
      unitTower: unitData.tower,
      unitID: unitData.id,
      unitName: unitData.name,
      unitArea: unitData.area,
      unitFloor: unitFloor,
      unitNumber: unitNumber,
      unitbasicPrice: tempBasicPrice.price,
      unitAdditionalCharges: []
    }
    setBasicPrices(unitData.basicPrice);
    setAdditionalChargesData(unitData.additionalCharges);
    setAdditionalCharges(unitData.additionalCharges);
    setSelectedData({
      ...selectedData,
      paymentPlan: {
        ...selectedPaymentPlan ? selectedPaymentPlan : ""
      },
      bookedUnit: tempUnitData
    })
  }

  function handleAdditionalCharges(e, addChar) {
    let tempCharges = additionalCharges ? [...additionalCharges] : [];
    if (e.target.checked) {
      tempCharges.push(addChar);
      setAdditionalCharges(tempCharges);
    } else {
      tempCharges = tempCharges.filter((doc) => {
        return doc !== addChar
      });
      setAdditionalCharges(tempCharges);
    }
  }

  function handleCloseData() {
    setSelectedData(null);
    setAdditionalCharges([]);
    handleClose();
  }

  function handleParseData() {
    let tempSelectedData = selectedData ? selectedData : null;
    let basicAmount = 0;
    let totalAdditionalCharges = 0;

    basicAmount = parseFloat(tempSelectedData.bookedUnit.unitArea) * parseFloat(tempSelectedData.bookedUnit.unitbasicPrice);

    additionalCharges.forEach(charge => {
      var tempCharge = charge.type === 'per' ? parseFloat(tempSelectedData.bookedUnit.unitArea) * parseFloat(charge.amount) : parseFloat(charge.amount);
      totalAdditionalCharges = parseFloat(totalAdditionalCharges) + parseFloat(tempCharge);
    });

    let propertyDetails = {
      ...tempSelectedData,
      bookedUnit: {
        ...tempSelectedData.bookedUnit,
        unitAdditionalCharges: additionalCharges ? additionalCharges : []
      }
    }

    handleResponse(
      propertyDetails,
      basicAmount,
      totalAdditionalCharges ? totalAdditionalCharges : 0,
      selectedPayments
    );

    handleCloseData();
  }

  return (
    <>
      <Button variant={buttonVariant} size={buttonSize} className={buttonClass} onClick={handleShow}>
        {buttonTitle ? buttonTitle : 'Button'}
      </Button>

      <Modal
        show={show}
        onHide={handleCloseData}
        backdrop="static"
        keyboard={false}
        size='xl'
        dialogClassName="modal-wrapper"
        contentClassName="modal-custom-content"
        centered
      >
        <div className='modal-head'>
          {
            units && units ?
              <div className='d-flex align-items-center justify-content-start'>
                <Button
                  variant='link'
                  size='sm'
                  className='text-dark p-1 rounded pe-3'
                  onClick={() => setUnits(null)}
                >
                  <IoArrowBackOutline size={22} />
                </Button>
                {
                  selectedData && selectedData.bookedUnit ?
                    <h5>Select Charges</h5>
                    :
                    <h5>Tower {selectedData.propTower.name}</h5>
                }
              </div>
              :
              <div className='d-flex align-items-center justify-content-start'>
                <h5 className='ps-1'>{title && title}</h5>
              </div>
          }
          <Button
            variant='link'
            size='sm'
            className='text-dark p-1 rounded'
            onClick={() => {
              handleCloseData();
            }}
          >
            <IoCloseOutline size={24} />
          </Button>
        </div>
        <div className='modal-body px-0 mt-3'>
          {
            units && units ?
              <>
                {
                  selectedData && selectedData.bookedUnit ?
                    <div className='px-3 w-100'>
                      <div className='p-3 bg-primary-light rounded d-flex justify-content-between'>
                        <div>
                          <p className='mb-0 fw-600'>{selectedData && selectedData.propName}</p>
                          <p className='mb-0 text-muted'>
                            <small>
                              {selectedData && selectedData.propNumber + ', '}
                              {selectedData && selectedData.propLocality + ', '}
                              {selectedData && selectedData.propCity + ', '}
                              {selectedData && selectedData.propState}
                            </small>
                          </p>
                        </div>
                        <div>
                          <p className='mb-0 fw-600'>Tower - {selectedData && selectedData.propTower && selectedData.propTower.name}</p>
                        </div>
                      </div>
                      <hr />
                      <div className='row bg-light rounded pt-3 px-3 align-items-center'>
                        <div className='col-md-4 mb-3'>
                          <p className='mb-0'>
                            {selectedData && selectedData.bookedUnit && selectedData.bookedUnit.unitName}
                            <small className='ms-2'>
                              (
                              <span>{selectedData && selectedData.bookedUnit && selectedData.bookedUnit.unitArea}</span>
                              <span className='ms-1'>{selectedData && selectedData.propUnitMeasure}</span>
                              )
                            </small>
                          </p>
                        </div>
                        <div className='col-md-4 mb-3'>
                          <p className='mb-0'>
                            <span>Floor - {selectedData && selectedData.bookedUnit && selectedData.bookedUnit.unitFloor},</span>
                            <span className='ms-1'>Unit Number - {selectedData && selectedData.bookedUnit && selectedData.bookedUnit.unitNumber}</span>
                          </p>
                        </div>
                        <div className='col-md-4 mb-3 text-end'>
                          <InputGroup>
                            <InputGroup.Text className='py-1'>Basic Price</InputGroup.Text>
                            <Form.Select
                              value={selectedData && selectedData.bookedUnit && selectedData.bookedUnit.unitbasicPrice}
                              className='py-0 border-left-0'
                              onChange={(event) => {
                                setSelectedData({
                                  ...selectedData,
                                  bookedUnit: {
                                    ...selectedData.bookedUnit,
                                    unitbasicPrice: event.target.value
                                  }
                                })
                              }}
                            >
                              {
                                basicPrices && basicPrices.map((p_item, p_index) => {
                                  return (
                                    <option key={p_index} value={p_item.price}>₹ {p_item.price}/{selectedData.propUnitMeasure}</option>
                                  )
                                })
                              }
                            </Form.Select>
                          </InputGroup>
                        </div>
                      </div>
                      <hr />
                      {
                        additionalChargesData && additionalChargesData ?
                          <p className='mb-0 px-3 text-muted mb-2 mt-3'>
                            <small>Additional Charges</small>
                          </p>
                          :
                          null
                      }
                      {
                        additionalChargesData && additionalChargesData.map((addChar, index) => {
                          return (
                            <div key={index} className='row rounded py-2 mt-2 mx-3' htmlFor={addChar}>
                              <div className='col-md-6'>
                                {addChar.name}
                              </div>
                              <div className='col-md-4'>
                                {
                                  addChar.type === 'per' ?
                                    `${addChar.amount}/${selectedData.propUnitMeasure}`
                                    :
                                    `${addChar.amount} only`
                                }
                              </div>
                              <div className='col-md-2 d-flex justify-content-end pe-3'>
                                <Form.Check
                                  id={addChar}
                                  type="checkbox"
                                  onChange={(e) => handleAdditionalCharges(e, addChar)}
                                  checked={additionalCharges && additionalCharges.find(adChar => adChar === addChar)}
                                />
                              </div>
                            </div>
                          )
                        })
                      }
                      <hr />
                      {
                        paymentPlans && paymentPlans ?
                          <div className='border rounded'>
                            <div className='d-flex align-items-center justify-content-between p-3 bg-primary-light'>
                              <div className='w-50'>
                                <h6 className='mb-0'>Payment Plan</h6>
                                <p className='mb-0 text-placeholder'>
                                  <small>(Please select your payable payment plan)</small>
                                </p>
                              </div>
                              <div className='w-50'>
                                <InputGroup>
                                  <Form.Select
                                    value={selectedPaymentPlan && selectedPaymentPlan.id}
                                    className='py-2 pe-5'
                                    onChange={(event) => {
                                      let tempDoc = paymentPlans && paymentPlans.find(x => x.id === event.target.value);
                                      setSelectedPaymentPlan({ id: tempDoc.id, name: tempDoc.name });
                                      setSelectedData({
                                        ...selectedData,
                                        paymentPlan: selectedPaymentPlan ? selectedPaymentPlan : ""
                                      });
                                      getPayments(selectedData && selectedData.propertyID, event.target.value);
                                    }}
                                  >
                                    {
                                      paymentPlans && paymentPlans.map((plan, planIndex) => {
                                        return (
                                          <option key={planIndex} value={plan.id}>{plan.name}</option>
                                        )
                                      })
                                    }
                                  </Form.Select>
                                </InputGroup>
                              </div>
                            </div>
                            {
                              selectedPayments && selectedPayments.length > 0 ?
                                <>
                                  {
                                    selectedPayments.map((item, index) => {
                                      return (
                                        <div key={index} className='bg-light border-top p-3'>
                                          <div className='d-flex align-items-center justify-content-between'>
                                            <div>
                                              <p className='mb-0'>{item.name}</p>
                                              <p className='mb-0 text-placeholder'>
                                                <small>
                                                  {item.description}
                                                </small>
                                              </p>
                                            </div>
                                            <div className='d-flex align-items-center justify-content-between'>
                                              <p className='mb-0'>{item.value}% of BP</p>
                                              {
                                                item.other ?
                                                  <p className='mb-0 ms-1'>+ {item.other}% of AC</p>
                                                  :
                                                  null
                                              }
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    })
                                  }
                                </>
                                :
                                <div className='bg-light border-top p-3 py-5 text-center'>
                                  <h5 className='text-muted mb-0'>Not available!</h5>
                                  <p className='mb-0 fw-light text-placeholder'>
                                    <small>(Please add payments to this payment plan.)</small>
                                  </p>
                                </div>
                            }
                          </div>
                          :
                          null
                      }
                    </div>
                    :
                    <>
                      <div className='px-3 mx-3 py-2'>
                        <div className='row w-100 text-muted text-center'>
                          <div className='col-md-1'>
                            <small>#</small>
                          </div>
                          <div className='col-md-3 text-start'>
                            <small>Unit Name</small>
                          </div>
                          <div className='col-md-2'>
                            <small>Area</small>
                          </div>
                          <div className='col-md-2'>
                            <small>Total Units</small>
                          </div>
                          <div className='col-md-2'>
                            <small>Booked</small>
                          </div>
                          <div className='col-md-2' />
                        </div>
                      </div>
                      <hr className='my-0' />
                      {
                        units && units.map((item, index) => {
                          return (
                            <div key={index} className='p-3 mx-3 bg-light custom-hover mt-1 rounded'>
                              <div className='row w-100 text-center'>
                                <div className='col-md-1 d-flex align-items-center justify-content-center'>
                                  <div className='rounded'>
                                    {index + 1}
                                  </div>
                                </div>
                                <div className='col-md-3 d-flex align-items-center justify-content-start'>
                                  <div className='text-start fw-600'>
                                    {item.name}
                                  </div>
                                </div>
                                <div className='col-md-2 d-flex align-items-center justify-content-center'>
                                  <div className='text-center'>
                                    {item.area} {item.unitMeasure}
                                  </div>
                                </div>
                                <div className='col-md-2 d-flex align-items-center justify-content-center'>
                                  <div className='text-center'>
                                    {item.numUnit}
                                  </div>
                                </div>
                                <div className='col-md-2 d-flex align-items-center justify-content-center'>
                                  <div className='text-center'>
                                    <BookedUnit propID={selectedProperty} towerID={item.tower.id} unitID={item.id} />
                                  </div>
                                </div>
                                <div className='col-md-2'>
                                  <SelectUnit
                                    propertyID={selectedProperty}
                                    item={item}
                                    buttonTitle={
                                      <div className='d-flex align-items-center justify-content-end'>
                                        <IoMdAdd size={18} />
                                        <small className='ps-1'>Select</small>
                                      </div>
                                    }
                                    buttonVariant="dark"
                                    buttonClass="py-1"
                                    setUnitNumberPerFloor={setUnitNumberPerFloor}
                                  />
                                </div>
                              </div>
                            </div>
                          )
                        })
                      }
                    </>
                }
              </>
              :
              <>
                <div className='modal-search'>
                  <div className='row px-3 pb-3'>
                    <div className='col-md-12'>
                      <Form.Group>
                        <Form.Control
                          placeholder='Search property by name or location'
                        />
                      </Form.Group>
                    </div>
                  </div>
                </div>
                {
                  data && data.map((item, index) => {
                    return (
                      <div key={index} className='mx-3'>
                        <Button
                          variant='light'
                          className='w-100 border-0 ps-2 mt-1'
                          key={index}
                          onClick={() => getTowers(item.id)}
                        >
                          <div className='bg-white px-2 rounded me-3'>
                            {index + 1}
                          </div>
                          <div className='w-100 d-flex align-items-center'>
                            <div className='text-start'>
                              {item.name}
                            </div>
                            <div className='text-end text-muted ms-3 ps-3 border-start'>
                              <small>
                                {item.number + ', '}
                                {item.locality + ', '}
                                {item.city + ', '}
                                {item.state}
                              </small>
                            </div>
                          </div>
                          <div className='text-end'>
                            <IoChevronForward />
                          </div>
                        </Button>
                        {
                          item && (item.id === selectedProperty) && towers && towers.length > 0 ?
                            <div className='ms-5 mt-1 bg-light p-3'>
                              {
                                towers && towers.map((tow, t) => {
                                  return (
                                    <Button
                                      variant='light'
                                      key={t}
                                      className={t === 0 ? 'w-100 p-2 ps-3 cursor-pointer border-0 d-flex align-items-center justify-content-between' : 'w-100 p-2 ps-3 cursor-pointer border-0 d-flex align-items-center justify-content-between'}
                                      onClick={() => {
                                        getPaymentPlans(item.id, tow.id);
                                        getPropertyUnits(item, tow, item.unitMeasure);
                                      }}
                                    >
                                      <div className='text-start text-capitalize fw-600'>
                                        Tower {tow.name}
                                      </div>
                                      <div className='d-flex align-items-center'>
                                        <IoChevronForward />
                                      </div>
                                    </Button>
                                  )
                                })
                              }
                            </div>
                            :
                            null
                        }
                      </div>
                    )
                  })
                }
              </>
          }
        </div>
        <div className='modal-footer'>
          <Button
            variant='outline-dark btn-cancel'
            onClick={handleCloseData}
          >
            Cancel
          </Button>
          <Button
            variant='primary btn-save'
            onClick={handleParseData}
          >
            Done
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default PropertiesModal;
